import {createSlice} from '@reduxjs/toolkit';
import {TranslatedLanguage} from 'hubbl-shared';
import {setIsBusy} from './GlobalThunks';
import {getInitialLanguage} from '../../i18n';

interface GlobalState {
  isBusy: boolean;
  preferredLanguage: TranslatedLanguage;
}

const initialState: GlobalState = {
  isBusy: false,
  preferredLanguage: getInitialLanguage(),
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setPreferredLanguage: (state, action) => {
      state.preferredLanguage = action.payload;
      // Save to localStorage for persistence across sessions
      localStorage.setItem('preferredLanguage', action.payload);
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsBusy.fulfilled, (state, action) => {
      state.isBusy = action.payload;
    });
  },
});

export const {setPreferredLanguage} = globalSlice.actions;

export const GlobalReducer = globalSlice.reducer;
